import React from "react"
import styled from "styled-components"
import SVG from "react-inlinesvg"

import Quote from '../../assets/svg/quote.svg'

const StyledWrapper = styled.section`
  position: relative;
  padding: 88px 20px;
  ${({ theme, ghost }) =>
    !ghost && `background: ${theme.colors.sectionLightBg};`}
  text-align: center;

  ${({ theme }) => theme.media.desktop} {
    padding: 160px 0;
  }
`

const StyledQuoteLeft = styled(SVG).attrs(props => ({
  src: props.src,
}))`
  position: absolute;
  z-index: -1;
  top: -16px;
  left: -30px;
  opacity: 0.66;
`

const StyledQuoteRight = styled(SVG).attrs(props => ({
  src: props.src,
}))`
  display: none;
  position: absolute;
  transform: rotate(180deg);
  z-index: -1;
  right: -30px;
  bottom: -16px;
  opacity: 0.66;

  ${({ theme }) => theme.media.desktop} {
    display: block;
  }
`

const QuoteSection = props => {
  return (
    <StyledWrapper {...props}>
      <StyledQuoteLeft src={Quote} />
      <StyledQuoteRight src={Quote} />
      {props.children}
    </StyledWrapper>
  )
}

QuoteSection.propTypes = {}

export default QuoteSection
